import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import { ModuleSettings } from "../../../../http/types/modules";
import AdminChemicalAnchorMappings from "./AdminChemicalAnchorMappings";
import AdminChemicalAnchors from "./AdminChemicalAnchors";

interface ConcreteResinAdminSettingsProps {
  moduleData: ModuleSettings;
}

// Each tab mounts, and loads its list, on its first opening.
const ConcreteResinAdminSettings: FC<ConcreteResinAdminSettingsProps> = () => {
  const i18n = useI18n();
  const resinTranslation = i18n.translation.concreteResinModule;

  return (
    <Tabs
      urlParameter="l_tab"
      tabs={[{ title: resinTranslation.chemicalAnchors }, { title: resinTranslation.anchorMappings }]}
      contents={[<AdminChemicalAnchors />, <AdminChemicalAnchorMappings />]}
    />
  );
};

export default ConcreteResinAdminSettings;
